export const TRANSLATIONS_ES = {
  "routes_Pages": "paginas",
  "routes_Dashboard": "Panel",
  "routes_Questionnaire": "Estándares",
  "routes_Stats": "Estadísticas",
  "routes_Settings": "Ajustes",
  "routes_Resouces": "Recursos",
  "routes_Contact": "Contacto",
  "routes_Downloads": "Descargas",
  "routes_Documentation": "Documentación",
  "dashboard_welcome_message": "Bienvenido al Panel del Sistema de Gestión de Accesibilidad 👋",
  "dashboard_label": "Todos sus datos de accesibilidad recopilados, estructurados y monitoreados en un solo lugar.",
  "gettingStartedCard_gettingStarted": "Empezando",
  "gettingStartedCard_gettinStartedDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elementum dui nunc, ac porta sem consequat nec. Pellentesco",
  "gettingStartedCard_Steps": "Recomendamos estos pasos para comenzar:",
  "gettingStartedCard_step1": "Leer la documentación",
  "gettingStartedCard_step2": "Descargue la lista de verificación",
  "gettingStartedCard_step3": "Consulta tus estadísticas",
  "companyCard_supportedStandards": "Estándares soportados:",
  "companyCard_companyInformation": "Información de la empresa",
  "companyCard_numberOfEmployees": "empleados",
  "propertyListPage_propertyList": "Lista de propiedades",
  "propertyListPage_dashboard": "Panel",
  "propertyListPage_Questionnaire": "Estándares",
  "propertyListPage_newProperty": "Nueva propiedad",
  "propertyListPage_textmapEdit": "Editar propiedad",
  "propertyListPage_textmapQuestionnaire": "Clasificar",
  "propertyListPage_textmapFacility": "Editar instalación",
  "propertyListPage_textmapNewProperty": "Nueva propiedad",
  "propertyListPage_createNewProperty": "Crear nueva propiedad",
  "propertyListPage_disabilityClassification": "Clasificación de discapacidad",
  "propertyListPage_editProperty": "Editar propiedad",
  "propertyListPage_editFacilities": "Editar instalaciones",
  "propertyListPage_classify": "Clasificar",
  "propertyListPage_search": "Buscar por nombre de propiedad",
  "propertyForm_propertyInformation": "1.1 Información de la propiedad",
  "propertyForm_standardType": "Tipo estándar",
  "propertyForm_fieldCannotBeChanged": "Este campo no se puede cambiar",
  "propertyForm_propertyCategory": "Categoría de propiedad",
  "propertyForm_typeOfProperty": "Tipo de propiedad",
  "propertyForm_propertyName": "Nombre de la propiedad",
  "propertyForm_propertyArea": "Cantidad de metros cuadrados de superficie del piso",
  "propertyForm_enterPropertyAddress": "1.1.2 Ingresar la dirección de la propiedad",
  "propertyForm_addressLocation": "Escriba la ubicación de la dirección a continuación",
  "propertyForm_mapNote": "Si es necesario, puedes ajustar el mapa para que el marcador esté en la ubicación correcta.",
  "propertyForm_keyPropertyData": "1.2 Datos clave de la propiedad",
  "propertyForm_floorsQuestion": "¿Cuantos pisos tiene su propiedad?",
  "propertyForm_roomsQuestion": "¿Cuántas habitaciones tiene su propiedad?",
  "propertyForm_disabledRoomsQuestion": "¿Cuántas habitaciones para discapacitados tiene su propiedad?",
  "propertyForm_alergyRoomsQuestion": "¿Cuántas salas para alérgicos tiene su propiedad?",
  "propertyForm_save": "Ahorrar",
  "propertyForm_propertyHotelTypeOptionsLabel_Hotel": "Hotel",
  "propertyForm_propertyHotelTypeOptionsLabel_Motel": "Motel",
  "propertyForm_propertyConvenienceStoreOptions_Candies": "Dulces",
  "propertyForm_propertyConvenienceStoreOptions_Newspapers": "Periódicos",
  "propertyForm_propertyConvenienceStoreOptions_TobaccoProducts": "Productos de tabaco",
  "propertyForm_propertyConvenienceStoreOptions_Toiletries": "Artículos de aseo",
  "propertyForm_propertyConvenienceStoreOptions_Store": "Almacenar",
  "propertyForm_propertyConvenienceStoreOptions_Supermarket": "Supermercado",
  "propertyForm_propertyDepartmentStoreOptions_Clothing": "Ropa",
  "propertyForm_propertyDepartmentStoreOptions_DepartmentStore": "Grandes almacenes",
  "propertyForm_propertyDepartmentStoreOptions_Electronics": "Electrónica",
  "propertyForm_propertyDepartmentStoreOptions_Garden": "Jardín",
  "propertyForm_propertyDepartmentStoreOptions_Household_goods": "Artículos de uso doméstico",
  "propertyForm_propertyDepartmentStoreOptions_Pets": "Mascotas",
  "propertyForm_propertyDepartmentStoreOptions_Toys": "juguetes",
  "propertyForm_propertyFoodAndDrinkOptions_bakery_and_baked_goods_store": "Panadería y tienda de productos horneados.",
  "propertyForm_propertyFoodAndDrinkOptions_dairy_goods": "productos lácteos",
  "propertyForm_propertyFoodAndDrinkOptions_food_and_drink": "Comida y bebida",
  "propertyForm_propertyFoodAndDrinkOptions_food_beverage_specialty_store": "Tienda especializada en alimentos y bebidas",
  "propertyForm_propertyFoodAndDrinkOptions_grocery": "Tienda de comestibles",
  "propertyForm_propertyFoodAndDrinkOptions_meat": "Carne",
  "propertyForm_propertyFoodAndDrinkOptions_specialty_food_store": "Tienda de alimentos especializados",
  "propertyForm_propertyFoodAndDrinkOptions_Vegan": "Vegano",
  "propertyForm_propertyFoodAndDrinkOptions_Vegetarian": "Vegetariano",
  "propertyForm_propertyFoodAndDrinkOptions_wine_and_liquor": "vino y licor",
  "propertyForm_propertyDrugstoreOptions_drugstore": "Farmacia",
  "propertyForm_propertyDrugstoreOptions_pharmacy": "Farmacia",
  "propertyForm_propertyElectronicsOptions_computer_and_software": "Computadora y software",
  "propertyForm_propertyElectronicsOptions_consumer_electronics_store": "Tienda de electrónica de consumo",
  "propertyForm_propertyElectronicsOptions_electronics": "Electrónica",
  "propertyForm_propertyElectronicsOptions_entertainment_electronics": "Electrónica_entretenimiento",
  "propertyForm_propertyElectronicsOptions_mobile_retailer": "minorista móvil",
  "propertyForm_propertyElectronicsOptions_mobile_service_center": "centro de servicio móvil",
  "propertyForm_propertyMallOptions_shopping_gallery_mall": "Centro comercial galería",
  "propertyForm_propertyMallOptions_shopping_mall": "Centro comercial",
  "propertyForm_standardTypeOptions_hotel_motel": "Hotel/Motel",
  "propertyForm_standardTypeOptions_shopping_mall": "Centro comercial",
  "propertyForm_standardTypeOptions_shop": "Comercio",
  "propertyForm_propertyHardwareOptions_floor_and_carpet": "Piso y alfombra",
  "propertyForm_propertyHardwareOptions_furniture_store": "Tienda de muebles",
  "propertyForm_propertyHardwareOptions_garden_center": "Centro del jardín",
  "propertyForm_propertyHardwareOptions_glass_and_window": "Vidrio y ventana",
  "propertyForm_propertyHardwareOptions_hardware_house_garden": "Jardín de la casa de hardware",
  "propertyForm_propertyHardwareOptions_home_improvement_hardware_store": "Ferretería para mejoras en el hogar",
  "propertyForm_propertyHardwareOptions_home_specialty_store": "Tienda especializada en el hogar",
  "propertyForm_propertyHardwareOptions_lumber": "Tablas de madera",
  "propertyForm_propertyHardwareOptions_major_appliance": "Electrodomésticos grandes",
  "propertyForm_propertyHardwareOptions_paint_store": "Tienda de pintura",
  "propertyForm_propertyHardwareOptions_power_equipment_dealer": "Distribuidor de equipos eléctricos",
  "propertyForm_propertyBookstoreOptions_bookstore": "Librería",
  "propertyForm_propertyClothingOptions_childrens_apparel": "Ropa para niños",
  "propertyForm_propertyClothingOptions_clothing_and_accessories": "Ropa y accesorios",
  "propertyForm_propertyClothingOptions_mens_apparel": "Ropa de Hombre",
  "propertyForm_propertyClothingOptions_shoes_footwear": "Zapatos calzado",
  "propertyForm_propertyClothingOptions_specialty_clothing_store": "Tienda de ropa especializada",
  "propertyForm_propertyClothingOptions_womens_apparel": "Ropa para Mujeres",
  "propertyForm_consumerGoodsOptions_adult_shop": "tienda para adultos",
  "propertyForm_consumerGoodsOptions_arts_and_crafts_supplies": "Suministros para artes y manualidades.",
  "propertyForm_consumerGoodsOptions_bicycle_and_bicycle_accessories_shop": "Tienda de bicicletas y accesorios para bicicletas.",
  "propertyForm_consumerGoodsOptions_camping_hiking_shop": "tienda de camping senderismo",
  "propertyForm_consumerGoodsOptions_canoe_kayak_shop": "tienda de canoas y kayaks",
  "propertyForm_consumerGoodsOptions_car_accessories": "Accesorios de coche",
  "propertyForm_consumerGoodsOptions_consumer_goods": "Bienes de consumo",
  "propertyForm_consumerGoodsOptions_cross_country_ski_shop": "Tienda de esquí de fondo",
  "propertyForm_consumerGoodsOptions_florist": "Florista",
  "propertyForm_consumerGoodsOptions_general_merchandise": "Mercancía general",
  "propertyForm_consumerGoodsOptions_gift_antique_art": "Regalo arte antiguo",
  "propertyForm_consumerGoodsOptions_hobby_store": "tienda de pasatiempos",
  "propertyForm_consumerGoodsOptions_hunting_fishing_shop": "tienda de caza y pesca",
  "propertyForm_consumerGoodsOptions_jeweler": "Joyero",
  "propertyForm_consumerGoodsOptions_market": "Mercado",
  "propertyForm_consumerGoodsOptions_motorcycle_accessories": "Accesorios para motos",
  "propertyForm_consumerGoodsOptions_non_store_retailers": "Minoristas que no son tiendas",
  "propertyForm_consumerGoodsOptions_office_supply_store": "Tienda de suministros de oficina",
  "propertyForm_consumerGoodsOptions_pawnshop": "Casa de empeño",
  "propertyForm_consumerGoodsOptions_pet_supply": "Suministro de mascotas",
  "propertyForm_consumerGoodsOptions_record_cd_video": "grabar vídeo en cd",
  "propertyForm_consumerGoodsOptions_running_walking_shop": "Tienda para correr y caminar.",
  "propertyForm_consumerGoodsOptions_skate_shop": "Tienda de patines",
  "propertyForm_consumerGoodsOptions_ski_snowboard_shop": "Tienda de esquí y snowboard",
  "propertyForm_consumerGoodsOptions_specialty_store": "Tienda de especialidades",
  "propertyForm_consumerGoodsOptions_sporting_goods_store": "Tienda de artículos deportivos",
  "propertyForm_consumerGoodsOptions_surf_shop": "Tienda de surf",
  "propertyForm_consumerGoodsOptions_tack_shop": "tienda de tachuelas",
  "propertyForm_consumerGoodsOptions_toy_store": "Tienda de juguetes",
  "propertyForm_consumerGoodsOptions_used_second_hand_merchandise_stores": "Tiendas de mercancías usadas de segunda mano.",
  "propertyForm_consumerGoodsOptions_variety_store": "Tienda de variedades",
  "propertyForm_consumerGoodsOptions_video_and_game_rental": "Alquiler de videos y juegos",
  "propertyForm_consumerGoodsOptions_warehouse_wholesale_store": "Almacén tienda mayorista",
  "propertyForm_hairAndBeautyOptions_barber": "Barbero",
  "propertyForm_hairAndBeautyOptions_hair_and_beauty": "Cabello y belleza",
  "propertyForm_hairAndBeautyOptions_hair_salon": "Peluquería",
  "propertyForm_hairAndBeautyOptions_nail_salon": "Manicura",
  "propertyForm_hairAndBeautyOptions_make_up_salon": "salón de maquillaje",
  "propertyForm_mallTopCategoryOptions_mall_shopping_complex": "Complejo comercial del centro comercial",
  "propertyForm_accomodationsCategoryOptions_hotel_motel": "Hotel/Motel",
  "propertyForm_shopCategoryOptions_convenience_store": "Tienda de conveniencia",
  "propertyForm_shopCategoryOptions_department_store": "grandes almacenes",
  "propertyForm_shopCategoryOptions_food_and_drink": "Comida y bebida",
  "propertyForm_shopCategoryOptions_drugstore_or_pharmacy": "Droguería o farmacia",
  "propertyForm_shopCategoryOptions_electronics": "Electrónica",
  "propertyForm_shopCategoryOptions_hardware_house_garden": "Jardín de la casa de hardware",
  "propertyForm_shopCategoryOptions_bookstore": "Librería",
  "propertyForm_shopCategoryOptions_clothing_and_accessories": "Ropa y accesorios",
  "propertyForm_shopCategoryOptions_consumer_goods": "Bienes de consumo",
  "propertyForm_shopCategoryOptions_hair_and_beauty": "Cabello y belleza",
  "facilitiesForm_standardTypeOptions_hotel_motel": "Hotel/Motel",
  "facilitiesForm_standardTypeOptions_office": "Oficina",
  "facilitiesForm_standardTypeOptions_shopping_mall": "Centro comercial",
  "facilitiesForm_standardTypeOptions_shop": "Comercio",
  "facilitiesForm_selectFacilitiesForDataCollection": "2. Seleccionar instalaciones para la recopilación de datos",
  "facilitiesForm_preselectedMandatoryItems": "Los siguientes elementos preseleccionados son obligatorios.",
  "facilitiesForm_mandatoryFacilitiesFor": "Instalaciones obligatorias para",
  "facilitiesForm_optionalFacilitiesFor": "Instalaciones opcionales para",
  "facilitiesForm_standard": "Estándar",
  "facilitiesForm_preselectedOptionalItems": "Los siguientes elementos son opcionales.",
  "facilitiesForm_faq_mandatoryFacilities": "¿Qué son las instalaciones obligatorias?",
  "facilitiesForm_faq_AnswerMandatoryFacilities": "Estas son instalaciones estándar que encontramos en propiedades de este tipo. Para generar nuestros datos de accesibilidad de forma exhaustiva es necesario evaluar estas instalaciones. EX la entrada del edificio",
  "facilitiesForm_faq_optionalFacilities": "¿Qué son las instalaciones opcionales?",
  "facilitiesForm_faq_AnswerOptionalFacilities": "Esta es una lista no exhaustiva de instalaciones que pueden existir o no en su propiedad, pero que no son necesariamente instalaciones estándar en una propiedad como la suya. Por ejemplo, un Spa en un hotel o en un Centro Comercial.",
  "unitForm_helperText_entrance_key": "Entrada",
  "unitForm_helperText_entrance_value": "es decir, entrada principal o entradas secundarias, como a través del restaurante o los jardines.",
  "unitForm_helperText_lobby_key": "Vestíbulo",
  "unitForm_helperText_lobby_value": "Es decir, vestíbulo principal de la propiedad, incluido el salón o la zona de espera.",
  "unitForm_helperText_reception_key": "Recepción/mostrador de información",
  "unitForm_helperText_reception_value": "es decir, mostrador de facturación principal, mostrador de conserjería, área de almacenamiento de equipaje o áreas de mostrador de información",
  "unitForm_helperText_facility_key": "Instalación",
  "unitForm_helperText_facility_value": "",
  "unitForm_helperText_parking_key": "Aparcamiento y alrededores cercanos.",
  "unitForm_helperText_parking_value": "es decir, área de estacionamiento principal y áreas exteriores adicionales como jardines, entradas para vehículos y pasarelas",
  "unitForm_helperText_commonAreas_key": "Áreas comunes",
  "unitForm_helperText_commonAreas_value": "Áreas públicas compartidas del hotel como Lobby Lounge, Pasillos, etc.",
  "unitForm_helperText_conferenceRoom_key": "Sala de conferencias/sala de reuniones",
  "unitForm_helperText_conferenceRoom_value": "",
  "unitForm_helperText_auditorium_key": "Sala",
  "unitForm_helperText_auditorium_value": "Espacio estilo teatro, cine, etc.",
  "unitForm_helperText_diningArea_key": "Comedor",
  "unitForm_helperText_diningArea_value": "por ejemplo, restaurante principal, área de desayuno buffet, lobby bar/bistro",
  "unitForm_helperText_toiletRoom_key": "Cuarto de baño (común, compartido)",
  "unitForm_helperText_toiletRoom_value": "es decir, baño/inodoro compartido accesible desde el vestíbulo, el restaurante u otras áreas públicas",
  "unitForm_helperText_gym_key": "Gimnasia",
  "unitForm_helperText_gym_value": "",
  "unitForm_helperText_spa_key": "Spa",
  "unitForm_helperText_spa_value": "",
  "unitForm_helperText_hospitalityRoom_key": "Tipo de habitación de hospitalidad",
  "unitForm_helperText_hospitalityRoom_value": "es decir, tipo de habitación, por ejemplo, individual, doble, accesible, familiar, etc.",
  "unitForm_quantityLabel": "Selecciona la cantidad",
  "unitForm_locationFaq": "¿Donde está localizado?",
  "unitForm_totalQuantity": "Cantidad total",
  "unitForm_floorSelection": "Seleccionar piso",
  "unitForm_finishedCreation": "¿Terminaste de crear unidades?",
  "unitForm_startClassifying": "Cuestionario!",
  "unitForm_unitData2": "Baño Privado",
  "unitForm_unitData3": "Baño privado",
  "unitForm_unitData4": "Cocina privada",
  "unitForm_unitTypeDetails": "3. Detalles del tipo de unidad:",
  "unitForm_unitName": "Escribe aquí el nombre de tu unidad",
  "unitForm_accessibleUnit": "Esta unidad se considera accesible.",
  "questionUnits_addNewUnit": "Agregar nueva unidad",
  "questionUnits_savedInfo": "Tu información fue guardada",
  "questionUnits_removedInfo": "Tu información fue eliminada",
  "questionUnits_resources": "Recursos",
  "questionUnits_uploadPictures": "Subir fotos",
  "questionUnits_explanation": "Algunas explicaciones/detalles sobre esta sección pueden ir aquí",
  "questionUnits_uploadLabel": "SUBIR",
  "questionUnits_unitExtraInfo": "Información adicional de la unidad",
  "questionUnits_unitExtraInfoPlaceholder1": "Aquí puedes insertar comentarios privados a esta unidad específica.",
  "questionUnits_unitExtraInfoPlaceholder2": "(actualmente no tienes comentarios sobre esta unidad)",
  "questionUnits_beforeClassification": "Deberías añadir instalaciones antes de empezar a clasificar.",
  "questionUnits_editFacilities": "Editar instalaciones",
  "questionUnits_addNew": "Haga clic en 'Agregar nuevo' o seleccione la unidad para comenzar a clasificar",
  "questionUnits_faq1": "Información",
  "questionUnits_faq2": "¿Qué son las instalaciones obligatorias?",
  "questionUnits_faq2_1": "Estas son instalaciones estándar que encontramos en propiedades de este tipo. Para generar nuestros datos de accesibilidad de forma exhaustiva es necesario evaluar estas instalaciones. EX la entrada del edificio",
  "questionUnits_faq3": "¿Qué son las instalaciones opcionales?",
  "questionUnits_faq3_1": "Esta es una lista no exhaustiva de instalaciones que pueden existir o no en su propiedad, pero que no son necesariamente instalaciones estándar en una propiedad como la suya. Por ejemplo, un Spa en un hotel o en un Centro Comercial.",
  "FAR_SelectProperty": "Seleccionar propiedad",
  "FAR_DocumentPreview": "Vista previa del documento:",
  "FAR_DownloadPDF": "Descargar PDF:",
  "FAR_Download": "¡Descargar ahora!",
  "CLP_SelectProperty": "Seleccionar propiedad",
  "CLP_SelectPropertyForChecklist": "Seleccione una propiedad para crear la lista de verificación",
  "CLP_AccessibilityChecklist": "Lista de verificación de accesibilidad",
  "CLP_GeneratedOn": "Generado en",
  "CLP_GeneratedBy": "Generado por",
  "CLP_LoadingDoc": "Cargando documento...",
  "CLP_DownloadNow": "¡Descargar ahora!",
  "A11yUnitsPageSubTitle": "Cosas a tener en cuenta",
  "A11yUnitsPageDescription": "Sólo podrás asociar unidades similares entre sí si son exactamente iguales. De lo contrario, se deberá crear otro tipo de unidad.",
  "routes_NewProperty": "Nueva propiedad",
  "routes_EditProperty": "Editar propiedad",
  "routes_EditFacility": "Editar instalación",
  "routes_SelectFacilities": "Seleccionar Instalaciones",
  "routes_CreateProperty": "Crear propiedad",
  "routes_Classify": "Clasificar",
  "routes_Blank": "Blanco",
  "changePassword_success": "Éxito",
  "changePassword_successMessage": "Tu contraseña ha sido actualizada",
  "changePassword_returnToLogin": "Volver a iniciar sesión",
  "changePassword_resetPassword": "Restablecer su contraseña",
  "changePassword_newPassword_label": "Nueva contraseña",
  "changePassword_confirmNewPassword_label": "Confirmar nueva contraseña",
  "changePassword_newPasswordRequired_errorMessage": "Se requiere nueva contraseña",
  "changePassword_newPasswordMismatch_errorMessage": "Las contraseñas deben coincidir",
  "changePassword_newPassword_browserTab": "Cambiar la contraseña",
  "DocumentationPage_pageTitle": "Página de documentación",
  "DocumentationPage_tabtitle": "Documentación",
  "DownloadsPage_pageTitle": "Página de descargas",
  "LanguagesDropdown_English": "Inglés",
  "LanguagesDropdown_French": "Francés",
  "LanguagesDropdown_German": "Alemán",
  "LanguagesDropdown_Dutch": "Holandés",
  "LocationAutocomplete_searchPlaceholder": "Buscar lugares...",
  "LocationAutocomplete_validAddress": "Por favor indique el número de casa y la calle.",
  "LocationAutocomplete_addressEmpty": "La dirección no puede estar vacía.",
  "page404_PageNotFound": "Página no encontrada.",
  "page404_PageNotFound_explanation": "Es posible que la página que estás buscando haya sido eliminada.",
  "page404_PageNotFound_returnHome_button": "Volver al sitio web",
  "page500_InternalError": "Error Interno del Servidor.",
  "page500_InternalError_explanation": "Servern stötte på något oväntat som intetilät den att slutföra begäran.",
  "propertyListPage_NotClassified": "No clasificado",
  "propertyListIconName_allergy_food_class": "Clase de alimentos para personas alérgicas",
  "propertyListIconName_allergy_room_class": "Clase de habitación para personas alérgicas",
  "propertyListIconName_mobility_class": "Clase de movilidad",
  "propertyListIconName_hearing_class": "Clase de audiencia",
  "propertyListIconName_cognitive_class": "Clase cognitiva",
  "propertyListIconName_visual_class": "clase visual",
  "propertyForm_AllStepsCompleted": "Todos los pasos completados",
  "propertyForm_propertyReady": "¡Tu propiedad ya está lista!",
  "propertyForm_propertyReady_description": "Ha finalizado el paso de información de su propiedad. Puede editar esta información haciendo clic en el enlace Lista de propiedades en el panel superior izquierdo.",
  "propertyForm_startClassifying": "COMENZAR A CLASIFICAR",
  "propertyForm_propertyStepper_step1": "Agregar información de propiedad",
  "propertyForm_propertyStepper_step2": "Seleccionar Instalaciones",
  "propertyForm_propertyStepper_step3": "Agregar detalles de la unidad",
  "settingsForms_CompanyInformation_SelectOptions_Service": "Servicio",
  "settingsForms_CompanyInformation_SelectOptions_Merchandising": "Comercialización",
  "settingsForms_CompanyInformation_SelectOptions_Manufacturing": "Fabricación",
  "settingsForms_CompanyInformation_SelectOptions_Other": "Otro",
  "settingsForms_ImageCantBeChanged": "Esta imagen no se puede cambiar.",
  "settingsForms_RegNumber_label": "Numero de registro",
  "settingsForms_InvoiceStatus_label": "Estado de la factura",
  "settingsForms_CompanyName_label": "nombre de empresa",
  "settingsForms_CompanyType_label": "Tipo de compañía",
  "settingsForms_CompanySize_label": "Tamaño de la empresa",
  "settingsForms_CompanyAddress_label": "Dirección de la empresa",
  "settingsForms_ContractDate_label": "Fecha de firma del contrato",
  "settingsForms_SubscriptionPeriod_label": "Periodo de suscripción",
  "settingsForms_Employees_label": "Empleados",
  "settingsForms_UserInformation_positionOptions_owner": "Dueño",
  "settingsForms_UserInformation_positionOptions_executive": "Ejecutivo",
  "settingsForms_UserInformation_positionOptions_manager": "Gerente",
  "settingsForms_UserInformation_positionOptions_operations_and_production": "Operaciones y producción",
  "settingsForms_UserInformation_positionOptions_other": "Otro",
  "settingsForms_UserInformation_departmentOptions_it": "ÉL",
  "settingsForms_UserInformation_departmentOptions_marketing": "Marketing",
  "settingsForms_UserInformation_departmentOptions_finance": "Finanzas",
  "settingsForms_UserInformation_departmentOptions_human_resources": "Recursos humanos",
  "settingsForms_UserInformation_departmentOptions_sales": "Ventas",
  "settingsForms_UserInformation_departmentOptions_operations": "Operaciones",
  "settingsForms_UserInformation_departmentOptions_other": "Otro",
  "settingsForms_UserInformation_title": "informacion del usuario",
  "settingsForms_UserInformation_UploadPicture": "Subir foto",
  "settingsForms_UserInformation_formatRestriction": "Utilice una imagen de al menos 128 px por 128 px en formato .jpg",
  "settingsForms_UserInformation_surname": "Apellido",
  "settingsForms_UserInformation_position": "Posición",
  "settingsForms_UserInformation_department": "Departamento",
  "settingsPage_pageTitle": "Página de configuración",
  "settingsPage_breadcrumbs_dashboard": "Panel",
  "settingsPage_breadcrumbs_settings": "Ajustes",
  "signinForm_explanation": "Inicia sesión en tu cuenta para continuar",
  "signinForm_validEmail_error": "Debe ser un correo electrónico válido",
  "signinForm_emailRequired": "correo electronico es requerido",
  "signinForm_generalError": "Algo salió mal",
  "signinForm_passwordRequired": "se requiere contraseña",
  "signinForm_emailLabel_textfield": "Dirección de correo electrónico",
  "signinForm_passwordLabel_textfield": "Contraseña",
  "signinForm_remberMeCheckbox_textfield": "Acuérdate de mí",
  "signinForm_signIn_button": "Iniciar sesión",
  "signinForm_forgotPassword_button": "Has olvidado tu contraseña",
  "signupForm_signUp_button": "Inscribirse",
  "signupForm_signUp_title": "Empezar",
  "signupForm_signUp_subTitle": "Comience a crear la mejor experiencia de usuario posible para sus clientes",
  "signupForm_signUp_nameRequired": "Se requiere el nombre",
  "signupForm_signUp_minCharacters_errorMessage": "Debe tener al menos 12 caracteres.",
  "signupForm_signUp_required_errorMessage": "Requerido",
  "signupForm_signUp_nameLabel": "Nombre",
  "signupForm_signUp_companyLabel": "Compañía",
  "signupForm_signUp_emailAddressLabel": "Dirección de correo electrónico",
  "signupForm_signUp_passwordLabel": "Contraseña",
  "signupForm_signUp_confirmPasswordLabel": "confirmar Contraseña",
  "statsPage_pageTitle": "Página de estadísticas",
  "statsPage_cardContent": "Esta página estará disponible en futuras versiones del Sistema de Gestión de Accesibilidad.",
  "resetPassword_inbox": "Revisa tu correo",
  "resetPassword_explanation_1": "Hemos enviado un correo electrónico a",
  "resetPassword_explanation_2": "con instrucciones de restauración de contraseña",
  "resetPassword_title": "Restablecer la contraseña",
  "resetPassword_subTitle": "Ingresa tu correo electrónico para restablecer tu contraseña",
  "unitForm_title": "Unidades compuestas",
  "unitForm_floorTitle": "Piso",
  "unitImagesDialog_labelMANDATORY": "OBLIGATORIO",
  "unitImagesDialog_labelOPTIONAL": "OPCIONAL",
  "unitImagesDialog_labelPICTURES": "FOTOS",
  "unitImagesDialog_dropzone": "Suelta fotos aquí o elige un archivo",
  "userDropdown_profile": "Perfil",
  "userDropdown_signout": "desconectar",
  "questionUnits_uploadPictures_uploadError": "Se produjo un error al cargar las imágenes.",
  "questionUnits_uploadSuccess": "Tus datos han sido enviados exitosamente",
  "questionUnits_unitExtraInfoLabel": "Información extra",
  "questionUnits_unitExtraInfoDelete_button": "Borrar",
  "questionUnits_unitExtraInfoSave_button": "Ahorrar",
  "QuestionnaireCompletionCard_title": "Cumplimiento de estándares",
  "QuestionnaireCompletionCard_disableMessage": "Aún no tienes ninguna clasificación.",
  "QuestionnaireCompletionCard_ParkingCard": "Estacionamiento",
  "QuestionnaireCompletionCard_EntranceCard": "Entrada",
  "QuestionnaireCompletionCard_ToiletCard": "Baño",
  "QuestionnaireCompletionCard_RoomsCard": "Habitaciones",
  "QuestionnaireCompletionCard_LiftAndElevatorsCard": "Ascensor y Ascensores",
  "QuestionnaireCompletionCard_LobbyAndReceptionCard": "Vestíbulo y recepción",
  "FAR_Report": "Informe de accesibilidad",
  "FAR_TableUnitName": "Nombre de la unidad",
  "FAR_TableDescription": "Descripción",
  "CLP_PleaseSelectProperty": "Por favor seleccione propiedad",
  "CLP_BrowserTabTitle": "Informe de accesibilidad completo",
  "CLP_UnitMandatoryLabel": "Obligatorio",
  "CLP_UnitDoneLabel": "HECHO",
  "propertyPage_Controllers_SearchDoc": "Buscar documentación",
  "generalWords_Yes": "Sí",
  "generalWords_No": "No",
  "generalWords_Next": "Próximo",
  "generalWords_Close": "Cerca",
  "generalWords_Reset": "Reiniciar",
  "generalWords_Back": "Atrás",
  "generalWords_Finish": "Finalizar",
  "generalWords_NextStep": "Próximo paso",
  "generalWords_Edit": "Editar",
  "generalWords_Download": "Descargar",
  "generalWords_Delete": "Borrar",
  "generalWords_SaveChanges": "Guardar cambios",
  "generalWords_Selected": "seleccionado",
  "generalWords_Required": "Requerido",
  "customerSupportPage_title": "Página de atención al cliente",
  "customerSupportPage_emailLabel": "Póngase en contacto con atención al cliente en:",
  "unitForm_helperText_entrance": "es decir, entrada principal o entradas secundarias, como por restaurante o jardines.",
  "unitForm_helperText_lobby": "es decir, vestíbulo principal de la propiedad que incluye salón o área de espera.",
  "unitForm_helperText_reception": "es decir, mostrador principal de facturación, mostrador de conserjería, área de almacenamiento de equipaje o áreas de mostrador de información.",
  "unitForm_helperText_facility": "es decir, el nombre de la instalación o propiedad.",
  "unitForm_helperText_parking": "es decir, área de estacionamiento principal y áreas exteriores adicionales como jardines, entradas para vehículos y pasarelas.",
  "unitForm_helperText_conferenceRoom": "Una sala de conferencias es una sala grande donde varias personas pueden celebrar una conferencia.",
  "unitForm_helperText_auditorium": "Espacio estilo teatro, cine, etc.",
  "unitForm_helperText_diningArea": "Por ejemplo, restaurante principal, zona de desayuno buffet, Lobby Bar/Bistro.",
  "unitForm_helperText_toiletRoom": "es decir, baño/inodoro compartido accesible desde el vestíbulo, el restaurante u otras áreas públicas.",
  "unitForm_helperText_gym": "Ejercicios físicos y actividades realizadas en el interior, a menudo utilizando equipos.",
  "unitForm_helperText_spa": "Lugar donde relajarse a través de sauna, piscina y jacuzzi.",
  "unitForm_helperText_hospitalityRoom": "es decir, tipo de habitación, por ejemplo, individual, doble, accesible, familiar, etc.",
  "unitForm_helperText_shopping_aisle": "es decir, pasillo entre los estantes.",
  "unitForm_helperText_counter": "Una superficie nivelada (como una mesa, estante o vitrina) sobre la cual se realizan las transacciones.",
  "unitForm_helperText_checkout_pay": "por ejemplo, Pago, Pago automático, Pago con escaneo automático.",
  "unitForm_helperText_fitting_room": "Una sala de una tienda en la que los clientes pueden ponerse una prenda de vestir para ver si les queda bien antes de comprarla.",
  "unitForm_helperText_manned_kiosk": "Una terminal de cambio o canje de efectivo, que permite realizar transacciones en efectivo y sin efectivo con un cajero.",
  "unitForm_helperText_floor": "es decir, la accesibilidad en diferentes niveles, como el ascensor en el primer piso y el ascensor verde en la entrada 2.",
  "unitForm_helperText_playground": "Zona utilizada por los niños para jugar. Suelen tener equipamiento como toboganes, columpios y balancines para que jueguen los niños.",
  "unitForm_helperText_garden": "Espacio, normalmente al aire libre, reservado para el cultivo, exhibición y disfrute de plantas y otras formas de la naturaleza.",
  "unitForm_helperText_bathroom_common": "Una habitación que contiene una bañera o ducha y normalmente un lavabo y un inodoro.",
  "unitForm_helperText_bathroom__private": "Una habitación privada que contiene una bañera o ducha y normalmente un lavabo y un inodoro.",
  "unitForm_helperText_quiet_room": "Una habitación silenciosa o habitación silenciosa es una habitación construida teniendo en cuenta el silencio protegiendo el ruido procedente del entorno o hacia él.",
  "unitForm_helperText_kitchen_common": "Una sala pública donde se pueden preparar y cocinar alimentos.",
  "unitForm_helperText_toilet_room__private": "es decir, baños privados accesibles desde el vestíbulo, restaurante u otras áreas públicas.",
  "unitForm_helperText_kitchen__private": "Una sala privada donde se pueden preparar y cocinar alimentos.",
  "unitForm_helperText_conferenceRoom_": "",
  "routes_Services": "Servicios",
  "routes_Help": "Ayuda",
  "routes_Clp": "Lista de Verificación",
  "routes_Far": "Informe de accesibilidad",
  "FAR_WhatIsItTitle": "¿Qué es un Informe de Accesibilidad?",
  "FAR_WhatIsItDescription": "El informe de Accesibilidad es un informe que generamos para usted dependiendo de qué tan accesible sea su propiedad. A continuación puede seleccionar una propiedad y descargar su informe en PDF.",
  "FAR_MoreInfo": "Para más información sobre el Informe de Accesibilidad por favor",
  "FAR_SelectPropertyForChecklist": "Seleccione una propiedad para crear el informe",
  "CLP_noChecklistFound": "No pudimos encontrar una lista para esta propiedad",
  "CLP_WhatIsItTitle": "¿Qué es una lista de verificación?",
  "CLP_WhatIsItDescription": "La Lista de verificación es una lista basada en la información del inventario del Sistema de Accesibilidad. Muestra las áreas de mejora, según sus aportaciones al sistema. Una vista previa del documento está disponible y se puede descargar o imprimir.",
  "CLP_MoreInfo": "Para obtener más información sobre la lista de verificación, por favor",
  "CLP_FAR_ConsultTheDocumentation": "consultar la documentación",
  "LanguagesDropdown_Swedish": "sueco",
  "LanguagesDropdown_Danish": "danés",
  "gettingStartedCard_step1_link": "Leer",
  "gettingStartedCard_step2_link": "Descargar",
  "gettingStartedCard_step3_link": "Controlar",
  "contactForm_category": "Categoría",
  "contactForm_title": "Contáctenos",
  "contactForm_chooseImg": "Elige imagen",
  "contactForm_submitBtn": "Enviar petición",
  "contactForm_attachBtnLabel": "Si es posible, adjunte una captura de pantalla.",
  "contactForm_messageLabel": "Por favor describa su solicitud aquí.",
  "contactForm_messageEmptyError": "Por favor agregue un mensaje",
  "contactForm_categoryOptions_ServiceInquiry": "Consulta de servicio",
  "contactForm_categoryOptions_TechnicalIssues": "Problemas técnicos",
  "contactForm_categoryOptions_OtherInquires": "Otras consultas",
  "contactForm_subtitle1": "Si no encuentras la respuesta que buscas, estamos aquí para echarte una mano.",
  "contactForm_subtitle2": "¡Por favor escríbanos! Nos comunicaremos con usted lo antes posible.",
  "FAR_noDataAvalible_1": "Aún no se puede generar el informe de accesibilidad para esta propiedad. Por favor complete el",
  "FAR_noDataAvalible_2": "para",
  "FAR_noDataAvalible_3": "primero.",
  "CLP_Updating": "Actualizando...",
  "CLP_AreYouSure": "¿Está seguro?",
  "CLP_UpdateMessage": "Si hace esto, el elemento desaparecerá de la lista de verificación y el estándar se actualizará automáticamente reflejando el cambio.",
  "CLP_Cancel": "CANCELAR",
  "CLP_YesUpdate": "SÍ, ACTUALIZAR",
  "CLP_WhatIsAChecklist": "¿Qué es una lista de verificación?",
  "CLP_Name": "Nombre",
  "CLP_pdfDisclaimer": "Nota: Una vez que realices las mejoras, no olvides actualizar tus datos de accesibilidad en la sección estándar.",
  "CLP_FAR_noAccessibilityDataAvailable1": "No tenemos ningún dato de accesibilidad disponible.",
  "CLP_noChecklist1": "La lista de verificación aún no se puede generar para esta propiedad. Responde las preguntas dentro del",
  "CLP_noChecklist2": "sección estándar",
  "CLP_noChecklist3": "para",
  "CLP_noChecklist4": "primero.",
  "CLP_FAR_noAccessibilityDataAvailable2": "Crear una propiedad",
  "CLP_FAR_noAccessibilityDataAvailable3": "y responda primero las preguntas dentro de la sección estándar.",
  "statsPage_subscriptionExpiring": "La suscripción vence en",
  "statsPage_days": "días",
  "statsPage_contactCustomerSupport": "Póngase en contacto con atención al cliente",
  "statsPage_companyInformation": "Información de la empresa",
  "statsPage_numberOfPhotosUploaded": "Número de fotos subidas",
  "statsPage_photos": "fotos",
  "statsPage_totalAmountProperties": "Cantidad total de propiedades",
  "statsPage_amountCompleted": "Cantidad completada",
  "statsPage_actionsPerVisitor": "Acciones por visitante en el Widget",
  "statsPage_yourItems": "Tus cosas",
  "statsPage_name": "Nombre",
  "statsPage_sku": "SKU",
  "statsPage_quantity": "Cantidad",
  "statsPage_numberOfUnits": "Número de unidades",
  "statsPage_accessible": "Accesible",
  "statsPage_notAccessible": "Inaccesible",
  "statsPage_unit": "Unidad",
  "statsPage_amount": "Cantidad",
  "statsPage_incomplete": "Incompleto",
  "statsPage_completed": "Terminado",
  "statsPage_notCompleted": "Sin completar",
  "statsPage_mobility": "Movilidad",
  "statsPage_cognitive": "Cognitivo",
  "statsPage_hearing": "Audiencia",
  "statsPage_visual": "Visual",
  "statsPage_allergy": "Alergia",
  "statsPage_class": "Clase",
  "statsPage_totalAccessibilityDatapoints": "Puntos de datos de accesibilidad total",
  "statsPage_visitorsThatOpened": "Visitantes que abrieron el Widget",
  "statsPage_visitorsInteraction": "Acciones totales en el Widget",
  "statsPage_action": "Acción",
  "statsPage_clicks": "Clics",
  "statsPage_noDataAvailable_topText": "No hay datos disponibles",
  "statsPage_noDataAvailable_bottomText": "En este momento",
  "statsPage_company_address": "DIRECCIÓN",
  "statsPage_company_city": "Ciudad",
  "statsPage_company_country": "País",
  "statsPage_company_name": "Nombre",
  "statsPage_company_type": "Tipo",
  "statsPage_company_registration_number": "Número de registro",
  "statsPage_company_logo": "Logo",
  "statsPage_company_employees": "Empleados",
  "statsPage_company_empty_fields": "Campos vacíos",
  "settingsPage_alertMsgImageUpload": "Haz clic en guardar para actualizar tu foto de perfil.",
  "settingsPage_alertMsgCompanyInformation_1": "Contacto",
  "settingsPage_alertMsgCompanyInformation_2": "Atención al cliente",
  "settingsPage_alertMsgCompanyInformation_3": "si necesita realizar cambios en la información de la empresa.",
  "documentationPage_downloadDocument": "Descargar documento",
  "documentationPage_loadingDocument": "Cargando documento",
  "CLP_Status": "Estado",
  "CLP_lastUpdate": "Última actualización",
  "CLP_completed": "terminado",
  "CLP_incomplete": "incompleto",
  "LanguagesDropdown_Languages": "Idiomas",
  "login_welcome_message": "Bienvenido al Sistema de Gestión de Accesibilidad 👋",
  "CLP_Checklist_is_generated_based": "La Lista de verificación se genera en función de los Datos de accesibilidad que recopilamos de su propiedad. Muestra las áreas de mejora y una vez que marcas el punto, la respuesta se actualiza automáticamente en el sistema y se cambiarán tus datos de accesibilidad. El documento se puede descargar para uso externo. Para más información",
  "CLP_Go_to_checklist": "Ir a la lista de verificación",
  "CLP_Updated_date": "Fecha actualizada",
  "CLP_The_purpose_of_Handiscover_1": "El propósito del inventario y la lista de verificación de Handiscover es guiarlo a medida que mejora su accesibilidad. La lista adjunta consta de varios elementos. Desde la perspectiva de que algo debe estar adaptado a la accesibilidad, hay puntos que son obligatorios. Además, identificamos puntos como por ejemplo recomendamos si construir nueva o reformar.",
  "CLP_List_points": "Lista de puntos",
  "CLP_Priority": "Prioridad",
  "CLP_User": "Usuario",
  "CLP_Mandatory": "Obligatorio",
  "CLP_Need_help": "¿Necesitas ayuda? Contacta con nuestro equipo",
  "CLP_Handiscovers_suggestions": "Las sugerencias de Handiscover",
  "propertyForm_nextStep_tooltip": "Complete todos los campos obligatorios primero",
  "statsPage_See_photos": "Ver fotos",
  "statsPage_Your_subscription": "Su suscripción",
  "statsPage_Filter_data_from": "Filtrar datos de",
  "statsPage_Filter_data_to": "Filtrar datos para",
  "statsPage_to": "a",
  "statsPage_Reload": "Recargar",
  "statsPage_Business_Metrics": "Métricas comerciales",
  "statsPage_Service_Metrics": "Métricas de servicio",
  "statsPage_Statistics_page": "Página de estadísticas",
  "imagesPage_Pictures_List": "Lista de imágenes",
  "imagesPage_Search_by_name": "Buscar por nombre",
  "imagesPage_No_pictures_available": "No hay fotos disponibles",
  "imagesPage_Name": "Nombre",
  "imagesPage_Display_in_widget": "Mostrar en widget",
  "imagesPage_Type": "Tipo",
  "imagesPage_Update_date": "Fecha de actualización",
  "imagesPage_Mandatory": "Obligatorio",
  "imagesPage_Are_your_sure": "¿Estás seguro?",
  "imagesPage_Delete": "Borrar",
  "imagesPage_Yes": "Sí",
  "imagesPage_Cancel": "Cancelar",
  "imagesPage_Open_image": "Abrir imagen",
  "imagesPage_Edit": "Editar",
  "imagesPage_Delete_image": "Eliminar Imagen",
  "CLP_The_purpose_of_Handiscover_2": "También hemos incluido puntos que son \"fáciles\" de solucionar pero que probablemente sean importantes desde la perspectiva de la accesibilidad.",
  "a11yUnits_The_title_has_been_translated": "El título ha sido traducido.",
  "statsPage_Statistics": "Estadísticas",
  "customerSupportPage_thankYou": "¡Gracias!",
  "customerSupportPage_requestSuccessfully": "Su solicitud ha sido enviada exitosamente. Nuestro servicio de atención al cliente se encargará de su solicitud y se comunicará con usted lo antes posible.",
  "customerSupportPage_warning": "Advertencia",
  "customerSupportPage_error": "Error",
  "propertyListPage_showAll": "Mostrar todo",
  "propertyListPage_completed": "Terminado",
  "propertyListPage_incomplete": "Incompleto",
  "dashboard": "Panel",
  "widget": "widget",
  "property_type": "Tipo de propiedad",
  "category": "Categoría",
  "edit_widget": "Editar widget",
  "created": "Creado",
  "published": "Publicado",
  "unpublished": "Inédito",
  "widget_info": "El widget de accesibilidad muestra datos de accesibilidad detallados previamente registrados en el Sistema de gestión de accesibilidad. Este widget permite crear mejores condiciones para que los visitantes planifiquen su estancia con antelación viendo la accesibilidad disponible. El widget de accesibilidad es interactivo ya que todos los datos actualizados en el sistema se reproducen en el widget.",
  "view_live_widget": "Ver widget en vivo",
  "no_widget_data_message": "No tenemos datos de widgets. Póngase en contacto con nuestro equipo de atención al cliente.",
  "image_list": "Lista de imágenes",
  "language_setting": "Configuración de idioma",
  "history": "Historia",
  "select_accessibility_unit": "Seleccionar unidad de accesibilidad",
  "add_new_image": "Agregar nueva imagen",
  "order": "Orden",
  "image": "Imagen",
  "description": "Descripción",
  "accessibility_unit": "Unidad de Accesibilidad",
  "accessibility": "Accesibilidad",
  "displayed_in_widget": "Mostrado en el widget",
  "current_image": "Imagen actual",
  "upload_new_picture": "Subir nueva imagen",
  "image_description": "descripción de la imagen",
  "image_order": "Orden de imagen",
  "back_to_list": "volver a la lista",
  "no_picture": "Sin imagen",
  "please_write_the_text_in": "Por favor escribe el texto en",
  "yes_delete": "SÍ, BORRAR",
  "delete_warning_text": "Si hace esto, el elemento desaparecerá del widget y el estándar se actualizará automáticamente reflejando el cambio.",
  "select_language_the_widget_provide": "Seleccione el idioma que proporciona el widget",
  "changed_by": "Cambiado por",
  "activity": "Actividad",
  "showing": "Demostración",
  "of": "de",
  "items": "elementos",
  "questionnaire": "Cuestionario",
  "we_are_showing_followings": "Estamos mostrando seguidores en su widget.",
  "we_are_recommended_to_state": "Se recomienda indicar alguna información práctica en el Widget para los visitantes de su propiedad. Si desea editarlo, comuníquese con nuestro servicio de atención al cliente.",
  "select_what_you_want_to_show": "Selecciona lo que quieres mostrar en el widget",
  "practical_information": "Información práctica",
  "you_can_add_maximum": "Puedes agregar máximo 3 oraciones.",
  "for_the_best_experiences_in_widget": "Para las mejores experiencias en Widget, te ayudaremos si lo deseas agregando más información.",
  "if_you_do_this_the_item_will_disappear": "Si haces esto, el elemento desaparecerá del widget.",
  "you_can_write_free_texts": "Puede escribir textos libres para agregar a la información general si es necesario. Máximo 40 caracteres",
  "write_a_new_information": "Escribe una nueva información.",
  "you_can_drag_and_drop_the_block": "Puedes arrastrar y soltar el bloque para cambiar los pedidos. Seleccione la casilla de verificación para presentar en el widget.",
  "you_can_freely_change_the_images_ordering": "Puede cambiar libremente el orden de las imágenes arrastrando y soltando.",
  "preview": "Avance",
  "add_point_on_map": "Añadir punto en el mapa",
  "LanguagesDropdown_Spanish": "Español",
  "LanguagesDropdown_Norwegian": "Noruego",
  "LanguagesDropdown_Portuguese": "Portugués",
  "LanguagesDropdown_Ukrainian": "Ucraniano",
  "main_unit_image": "Imagen(es) de la unidad principal",
  "item_pictures": "Imágenes del artículo",
  "please_choose_a_main_unit_image": "Elija una imagen de la unidad principal",
  "please_choose_a_item_picture": "Elija una imagen del artículo",
  "button_settings_updated": "La configuración de los botones se ha actualizado correctamente",
  "button_settings_created": "La configuración de los botones se ha creado correctamente",
  "button_settings": "Configuración de los botones",
  "webmaster_instruction": "Instrucciones para webmasters",
  "contract_has_expired": "Su contrato ha expirado. El widget ha sido suspendido. Póngase en contacto con el servicio de asistencia",
  "webmaster_instructions_are_not_available": "Las instrucciones para webmasters no están disponibles en este momento. Contactar con el servicio de asistencia",
  "create_api_key": "Crear clave API para esta empresa",
  "standard_instruction": "Instrucción estándar",
  "google_tag_manager_instruction": "Instrucciones de Google Tag Manager"
}